<template>
	<div class="answer">
		<div class="feedback-header">
			<ximg
				:src="avatarUrl"
				:style="avatarStyle"
				class="avatar-small pixelated"
				eager
				ariaLabel="user avatar"
				role="img"
			/>
			<div class="username-and-knighthood">
				<router-link
					v-if="answer.user && answer.user.isPublicProfile && ! answer.isAnonymous"
					:to="userPath"
					class="username"
				>
					{{ answer.user.username }}
					<span
						v-if="answer.isOfficial"
						class="wh-logo"
						:title=" answer.isOfficial ? 'Svar från Webhallen' : null"
					/>
				</router-link>
				<span v-else class="username">
					{{ answer.user && ! answer.isAnonymous ? answer.user.username : 'No-Face' }}
					<span
						v-if="answer.isOfficial"
						class="wh-logo"
						:title=" answer.isOfficial ? 'Svar från Webhallen' : null"
					/>
				</span>
				<knighthood-icon v-if="answer.user && answer.user.knighthood > 0" />
			</div>
			<span
				v-if="answer.user"
				class="level sub-title"
			>
				Lvl {{ answer.user.rankLevel }} {{ answer.user.avatar.class.title }}
			</span>
			<span class="posted sub-title">{{ postedString }}</span>
			<div class="votes">
				<span
					:class="['vote vote-up', { active: usersVote > 0 }]"
					@click="vote(1)"
				>{{ answer.upvotes }}</span>
				<span
					@click="vote(-1)"
					:class="['vote vote-down', { active: usersVote < 0 }]"
				>{{ answer.downvotes }}</span>
			</div>
		</div>
		<p class="text">
			<span class="semibold">Svar: </span>
			{{ answer.text }}
		</p>
	</div>
</template>
<script>
import { mapGetters } from 'vuex';
import alert from 'alert';
import memberUtils from 'utils/member';
import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import svLocale from 'date-fns/locale/sv';
import { memberRoute } from 'utils';

export default {
	props: {
		answer: {
			type: Object,
			required: true,
		},
		userVotes: {
			type: Object,
			default: function () {
				return {};
			},
		},
	},
	computed: {
		userPath () {
			return this.$router.route(memberRoute(this.answer.user, 'member.achievements'));
		},
		postedString () {
			const string = distanceInWordsToNow(this.answer.createdAt * 1000, {
				locale: svLocale,
				addSuffix: true,
				onlyNumeric: true,
			});
			return string;
		},
		avatarStyle () {
			return memberUtils.avatarStyle(this.answer);
		},
		avatarUrl () {
			return memberUtils.avatarUrl(this.answer);
		},
		usersVote: {
			get () {
				return this.userVotes[this.answer.id] || 0;
			},
			set (val) {
				Vue.set(this.userVotes, this.answer.id, val);
			},
		},
		...mapGetters ({
			isLoggedIn: 'user/isLoggedIn',
		}),
	},
	methods: {
		vote (newVote) {
			if (! this.isLoggedIn) {
				alert('Endast medlemmar kan rösta!');
				return;
			}
			if (this.usersVote === 1) {
				this.answer.upvotes--;
			} else if (this.usersVote === -1) {
				this.answer.downvotes--;
			}
			if (this.usersVote === newVote) {
				newVote = 0;
			}
			this.usersVote = newVote;
			if (newVote === 1) {
				this.answer.upvotes++;
			} else if (newVote === -1) {
				this.answer.downvotes++;
			}
			waja.put('comment/' + this.answer.id + '/vote')
				.data({
					vote: newVote,
				})
				.on('success', res => {
					alert('Tack för din röst!');
				})
				.go();
			//@TODO error handler
		},
	},
};
</script>
